import { render, staticRenderFns } from "./vulnCard.vue?vue&type=template&id=79e40e6e&scoped=true&"
import script from "./vulnCard.vue?vue&type=script&lang=ts&"
export * from "./vulnCard.vue?vue&type=script&lang=ts&"
import style0 from "./vulnCard.vue?vue&type=style&index=0&id=79e40e6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e40e6e",
  null
  
)

export default component.exports